import { render, staticRenderFns } from "./MedicineBatchStock.vue?vue&type=template&id=70a686da&scoped=true&"
import script from "./MedicineBatchStock.vue?vue&type=script&lang=js&"
export * from "./MedicineBatchStock.vue?vue&type=script&lang=js&"
import style0 from "./MedicineBatchStock.vue?vue&type=style&index=0&id=70a686da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a686da",
  null
  
)

export default component.exports